<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputsEx"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick" />
        <hr />
        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item
                    @click="handleExportClick">
                    Export
                </b-dropdown-item>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleStatusClick">
                    Change status
                </b-dropdown-item>
                <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                                 @click="handleTaskClick">
                    Mark As
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <hr />
        <transition name="fade">
            <select-status 
                v-if="showStatus && (selectedItems && selectedItems.length > 0)"
                :statuses="manualStatuses" 
                :reasons="declinationReasons" 
                :button_text="`Set Status (${selectedItems.length} records)`"
                class="mb-2 border-bottom"
                @button-click="handleUpdateSelectedClick"/>
        </transition>

        <transition name="fade">
            <select-task
                v-if="showFlag && (selectedItems && selectedItems.length > 0)"
                :tasks="options"
                :button_text="`Set Task (${selectedItems.length} records)`"
                class="mb-2 border-bottom"
                @button-click="handleUpdateFlagsClick" />
        </transition>

        <transition name="fade">
            <data-list-csv 
                 v-if="showExport"
                class="mb-2 border-bottom"
                :dataCols="claimsCols"
                :dataListItems="claimsList"
                :selectedItems="selectedItems">
            </data-list-csv>
            
        </transition>
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="handleSearchClick(searchPayload)" />
            </div>
            <div class="col">
                <order-by v-model="selectedOrderBy"
                          :options="orderByOptions"
                          @goClick="handleOrderByClick" />
            </div>
        </div>

        <data-list :dataCols="claimsCols"
                   :dataListItems="claimsList"
                   :tableClass="'table table-striped table-sm'"
                   :showCheckbox="true"
                   @change="handleSelectedItemsChange"
                   @dbl-click="handleItemDblClick" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="handlePagenationInput" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>
import claimsSearch from '@/mixins/claimsSearch.js'
import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
import DataListCSV from '@/components/DataListCSV.vue'
import SelectStatus from '@/components/SelectStatus.vue'
import SelectTask from '@/components/SelectTask.vue'
import PageSize from '@/components/PageSize.vue'
import SearchForm from '@/components/SearchForm.vue'
import { searchInputs } from '@/ui.config/inputs/claimsBucket1SearchInputs'
import { claimsCols } from '@/ui.config/cols/claimsBucket1ClaimsCols'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name:'ClaimsBucket1',
    mixins: [
        claimsSearch,
    ],
    props: ['fastTrack'],
    components: {
        PageHeader,
        DataList,
        'data-list-csv': DataListCSV,
        'select-status': SelectStatus,
        'select-task': SelectTask,
        PageSize,
        SearchForm,
        Loading,
        OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'FT Claims Review',
            },
            searchInputs: searchInputs,
            claimsCols: claimsCols,

            // TEST
            selected: [], // Must be an array reference!
            options: [
                { text: 'Manually reviewed', value: '1013' }
            ],

            // Override mixin
            orderByOptions: [
                {
                    id: 0,
                    key: 'ClaimantEmail',
                    label: 'Claimant Email'
                },
                {
                    id: 1,
                    key: 'DateCreated',
                    label: 'Submitted Date'
                },
                {
                    id: 2,
                    key: 'IncidentDate',
                    label: 'incident Date'
                }
            ],

            updatedStatus: null,
            selectedDeclinationReason: null,
            
        }
    },
    beforeMount() {
        this.claimsSearch(null, 1)
        this.fetchResellers()
        this.fetchIncidentTypes()
        this.fetchDeclinationReasons()
        this.fetchManualStatuses()
    },
    computed: {
        searchInputsEx() {
            var { resellers, incidentTypes,  searchInputs } = this

            if (resellers) {
                searchInputs[0].options = resellers
            }

            if (incidentTypes) {
                searchInputs[5].options = incidentTypes
            }

            return searchInputs
        },
    },
    methods: {
        buildSearchCriteria(searchValues, pageNumber) {
            let ordering = {
                orderBy: this.orderBy,
                sortDirection: this.sortDirection
            }

            let pages = {
                pageSize: this.pageSize,
                pageNumber: pageNumber
            }

            let criteria = {
                ...searchValues,
                fastTrack: this.fastTrack,
                ...ordering,
                ...pages
            }

            return criteria
        },
        handleUpdateSelectedClick(evPayload) {
            let { status: updatedStatus, reason: selectedDeclinationReason } = evPayload
            let { selectedItems } = this

            this.updatedStatus = null
            this.selectedDeclinationReason = null
            this.selectedItems = []
            this.showStatus = false

            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            let payload = {
                claimSearchCriteria: criteria,
                statusId: updatedStatus ? updatedStatus.id : null,
                reasonId: selectedDeclinationReason ? selectedDeclinationReason.id : null,
                claims: selectedItems.map(i => {
                    return {
                        claimId: i.claimId,
                        rowVersion: i.claimRowVersion
                    }
                })
            }
            this.updateClaims(payload)
        },
        handleUpdateFlagsClick(evPayload) {
            let selected = evPayload

            let { selectedItems } = this
            let criteria = this.buildSearchCriteria(this.buildSearchValues(this.searchPayload))
            this.selectedItems = []
            this.selected = null
            this.showFlag = false

            this.updateClaimsTaskFlags(
                {
                    claimSearchCriteria: criteria,
                    claims: selectedItems.map(i => {
                        return {
                            claimId: i.claimId,
                            rowVersion: i.claimRowVersion
                        }
                    }),
                    taskFlags: selected
                }
            )
        },
    }
}
</script>

<style>

</style>
